<template>
  <section class="margin-top-s">
    <div v-if="diffSalesTrack > 0" class="flex w100" style="padding-top: 4px; padding-bottom: 4px;">
        <p><b>Atenção:</b> {{ diffSalesTrack | number }} vendas sem <b>TRACKEAMENTO</b>. Confira se a configuração de UTMS está correta.</p>
    </div>
    <!-- Barra de rolagem superior -->
    <div class="scrollbar-top">
      <div class="scroll-content"></div>
    </div>
    <div class="box ads">
      <div class="box-content">
        <ul class="list-itens"  :class="{item10: isMax10, item20: isMax20,  item30: isMax30,  }">
          <li>
            <div class="flex between">
              <div class="flex-3 elem-name">
                <b>Nome do Anúncio</b>
              </div>
              <div class="elem-first-stats flex-1 txt-center">
                <b>Criativo</b>
              </div>
              <div 
                v-for="(item, k) in columnsOrder"
                :key="k"
                v-show="columns[item.name]"
                class="flex-1 txt-center"
              >
                <b>{{ item.label }}</b>
                <span class="info tooltip" v-if="item.tooltip">
                    <span class="tooltiptext">{{ item.tooltip }}</span>
                </span>
              </div>
            </div>
          </li>
          <li v-for="(ad, index) in ads" :key="index">
            <div class="flex middle w100" :class="{selected: ad.selected}">
              <!-- name -->
              <div class="flex-3 elem-name flex middle" :class="{selected: ad.selected}">
                <div class="flex middle">
                  <div class="flex middle">
                    <input type="checkbox" v-model="ad.selected" />
                  </div>
                  <div style="margin-left: 8px">
                    <m-switch
                      v-if="ad.platform === 'FBADS'"
                      v-model="ad.status"
                      @change="
                        showModalSwitchStatus = true;
                        selectedAd = ad;
                      "
                    ></m-switch>
                  </div>
                  <div style="margin-left: 8px">
                    <i
                      v-if="ad.platform === 'FBADS'"
                      class="fa fa-facebook-square fbads"
                    ></i>
                    <i
                      v-if="ad.platform === 'GADS'"
                      class="fab fa-google gads"
                    ></i>
                    {{ ad.name | protect }}
                  </div>
                </div>
              </div>
              <!-- imagem -->
              <div class="elem-first-stats flex-1 txt-center">
                <div
                  v-if="ad.platform === 'FBADS'"
                  class="button secondary small"
                  @click="generateUrlAd(ad)"
                >
                  Ver Criativo
                </div>
              </div>
              <div 
                v-for="(item, k) in columnsOrder"
                :key="k"
                v-show="columns[item.name]"
                class="flex-1 txt-center"
              >
                <div v-if="['roas', 'profit', 'profit_value'].includes(item.name)">
                  <!-- roas -->
                  <div  v-if="item.name == 'roas'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('roas', ad.id) < 1, positive:  getValueC('roas', ad.id) >= 1 }" >
                        {{ getValueC('roas', ad.id) | number }}x
                      </span>
                  </div>
                  <!-- profit -->
                  <div  v-if="item.name == 'profit'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('profit', ad.id) <= 0, positive:  getValueC('profit', ad.id) > 0 }" >
                        {{ getValueC('profit', ad.id) | number }}%
                      </span>
                  </div>
                  <!-- profit_value -->
                  <div  v-if="item.name == 'profit_value'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('profit_value', ad.id) <= 0, positive:  getValueC('profit_value', ad.id) > 0 }" >
                        {{ getValueC('profit_value', ad.id) | money }}
                      </span>
                  </div>
                </div>
                <div v-else>
                  <span v-if="item.filter && item.filter=='money'" >
                    {{  getValueC(item.name, ad.id) | money }}<span v-if="item.suffix">{{ item.suffix }}</span>
                  </span>
                  <span v-else>
                    {{  getValueC(item.name, ad.id) | number }}<span v-if="item.suffix">{{ item.suffix }}</span>
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>

    <div class="flex-1 flex row w100 middle">
      <div class="flex w100 center filters-groupo-holder">
        <div class="flex between middle">
          <paginate
            :containerClass="'pagination'"
            :page-count="totalPages"
            v-model="page"
            :page-range="5"
            :prev-text="'Anterior'"
            :next-text="'Próxima'"
          ></paginate>
        </div>
      </div>
    </div>

    <modal
      title="Criativo"
      :show="showModalAd"
      :largebox="false"
      @close="
        showModalAd = false;
        urlThumb = null;
      "
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <div v-if="loadingAd" class="flex w100 center">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
          <div v-else class="flex w100 center">
            <img v-if="!urlVideo" :src="urlThumb" class="img-criativo"/>
            <video v-else :src="urlVideo"  class="img-criativo" controls></video>
          </div>
          <div class="flex w100 center margin-top-l">
            <div
              class="button secondary"
              @click="
                showModalAd = false;
                urlThumb = null;
              "
            >
              FECHAR
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalSwitchStatus"
      description="Você tem certeza que deseja alterar o Status?"
      @cancel="
        selectedAd.status = !selectedAd.status;
        showModalSwitchStatus = false;
        selectedAd = null;
      "
      @accept="changeStatusAd(selectedAd)"
    ></modal-confirm>
  </section>
</template>

<script>
import {
  getAdsFacebook,
  getAdsGoogle,
  generateUrlAd,
  updateStatusFBADS,
  updateStatusGADS,
} from "@/services/campaigns";

import { getReportCampaigns } from "@/services/campaignsReport";

import { mapState } from "vuex";

import MSwitch from "@/components/MSwitch.vue";
import ModalConfirm from "@/components/modal/ModalConfirm";

import Modal from "@/components/modal/Modal";

export default {
  name: "ad",
  components: {
    MSwitch,
    ModalConfirm,
    Modal,
  },
  props: [
    "filters",
    "columns",
    "columnsOrder",
    "campaignsFilter",
    "adGroupFilter",
    "accountsFilter"
  ],
  data() {
    return {
      loading: false,
      loadingAd:false,
      showModalAd: false,
      showModalSwitchStatus: false,
      urlThumb: null,
      urlVideo: null,
      selectedAd: null,
      ads: [],
      reportAds: {},
      stats: {},
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      totalItens: 0,
      offset: 20,
      page: 1,
    };
  },
  mounted() {
    if (
      !this.campaignsFilter ||
      (this.campaignsFilter && this.campaignsFilter.length === 0)
    ) {
      this.$toast.error({
        title:'Erro',
        message:'Selecione ao menos uma campanha'
      })
      this.$router.push({ name: "CampaignDash", params: { slug: "campaign" } });
    }

    this.getAllAds();
    this.getReportAds();

    this.syncScrools();

    this.auxFilters = this.filters;
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    totalPages() {
      let valueMode = this.totalItens % this.offset;
      let value = this.totalItens / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    diffSalesTrack() {
      if (!this.stats.sales) {
        return 0
      }

      return this.stats.sales - this.stats.lh_sales
    },
    isMax10() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 10;
    },
    isMax20() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 20;
    },
    isMax30() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 30;
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.ads = [];
        this.getAllAds();
        this.getReportAds();
      },
    },
    page: {
      handler() {
        this.ads = [];
        this.getAllAds();
      },
    },
    accountsFilter: {
      handler() {
        this.ads = [];
        this.getAllAds();
        this.getReportAds();
      },
      deep: true,
    },
    campaignsFilter: {
      handler() {
        this.ads = [];
        this.getAllAds();
        this.getReportAds();
      },
      deep: true,
    },
    adGroupFilter: {
      handler() {
        this.ads = [];
        this.getAllAds();
        this.getReportAds();
      },
      deep: true,
    },
  },
  methods: {
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    syncScrools() {
      const campaignDiv = document.querySelector(".ads");
      const listItens = document.querySelector(".list-itens");
      const scrollContent = document.querySelector(
        ".scrollbar-top .scroll-content"
      );
      const topScrollbar = document.querySelector(".scrollbar-top");

      // Função para sincronizar o scroll
      function syncScrollbars() {
        // Sincronizar a rolagem
        topScrollbar.scrollLeft = campaignDiv.scrollLeft;

        // Ajustar a largura da barra de rolagem superior para ser a mesma que a do conteúdo
        scrollContent.style.width = listItens.scrollWidth + "px";
        scrollContent.style.height = "10px";
      }

      //Adicionar evento de rolagem para sincronizar as barras
      campaignDiv.addEventListener("scroll", () => {
        topScrollbar.scrollLeft = campaignDiv.scrollLeft;
      });

      // Adicionar evento de rolagem para sincronizar as barras
      topScrollbar.addEventListener("scroll", () => {
        campaignDiv.scrollLeft = topScrollbar.scrollLeft;
      });

      // Sincronizar ao carregar a página e ao redimensionar a janela
      window.addEventListener("load", syncScrollbars);
      window.addEventListener("resize", syncScrollbars);
    },
    getValueC(attr, adId) {
      if (!this.reportAds[adId]) {
        return 0;
      }

      return this.reportAds[adId][attr];
    },
    changeStatusAd(ad) {
      if (ad.platform === "FBADS") {
        this.updateStatusFBADS(ad);
      } else if (ad.platform === "GADS") {
        this.updateStatusGADS(ad);
      }

      this.showModalSwitchStatus = false;
      this.selectedAd = null;
    },
    updateStatusFBADS(ad) {
      let params = {
        type: "AD",
        id: ad.id,
        ad_account_id: ad.ad_account_id,
        status: ad.status,
      };

      updateStatusFBADS(params)
        .then((result) => {
          console.log("result", result);
          this.$toast.success({
            title: "Sucesso",
            message: "Campanha editada com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateStatusGADS(ad) {
      let params = {
        type: "AD",
        id: ad.id,
        ad_account_id: ad.ad_account_id,
        status: ad.status,
      };

      updateStatusGADS(params)
        .then((result) => {
          console.log("result", result);
          this.$toast.success({
            title: "Sucesso",
            message: "Campanha editada com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    getReportAds() {
      const date = this.filters && this.filters.data && this.filters.data.date;

      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        tracking: this.filters && this.filters.data.tracking,
      };
      getReportCampaigns(params)
        .then((result) => {
          this.reportAds = result.ads;
          this.stats = result.stats

        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    generateUrlAd(ad) {
      let params = {
        ad: ad.id,
        ad_account_id: ad.ad_account_id,
      };
      this.showModalAd = true;

      this.loadingAd = true

      generateUrlAd(params)
        .then((result) => {
          this.urlThumb = result.thumbnail_url;
          this.urlVideo = result.video_url;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema",
          });
        })
        .finally(() => {
          this.loadingAd = false
        })
    },
    getAllAds() {
      this.loading = true;
      const date = this.filters && this.filters.data && this.filters.data.date;
      let params = {
        page: this.page,
        offset: this.offset,
        tracking: this.filters && this.filters.data.tracking,
        campaigns: this.campaignsFilter && this.campaignsFilter.join(","),
        adgroups: this.adGroupFilter && this.adGroupFilter.join(","),
        accounts: this.accountsFilter && this.accountsFilter.join(','),
      };
      if (date) {
        params = Object.assign(params, {
          start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
          end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        });
      }

      this.totalItens = 0;
      Promise.all([
        getAdsFacebook(params).then((result) => {
          this.totalItens += result.total;

          this.ads = this.ads.concat(
            result.ads.map((c) => {
              return { ...c, platform: "FBADS", spend: 0, budget: 0, selected: false, };
            })
          );
        }),
        getAdsGoogle(params).then((result) => {
          this.totalItens += result.total;

          this.ads = this.ads.concat(
            result.ads.map((c) => {
              return { ...c, platform: "GADS", spend: 0, budget: 0, selected: false, };
            })
          );
        }),
      ])
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar Ad Groups",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-itens {
  min-width: 1500px;
;

  li {
    list-style-type: none;
    padding: 8px 4px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    > div {
      min-height: 26px;
    }
  }

  &.item10 {
    min-width: 3000px;
  }
  &.item20 {
    min-width: 5000px;
  }
  &.item30 {
    min-width: 6000px;
  }
}

.ads {
  overflow-x: scroll;
  width: 100%;

  .input {
    height: 36px;
    min-width: 140px;
    text-align: center;
  }
}

.fbads {
  color: blue;
}
.gads {
  color: red;
}

.small {
  padding: 4px 8px;
}
.img-criativo {
  border: 2px solid #c2c2c2;
  max-width: 640px;
  max-height:640px;
}
.lh-color {
  color: var(--terciary);
  font-weight: 800;
  background: #ededed;
  // border: 1px solid #c3c3c3;
  padding: 8px 4px;
  // border-radius: 5px;
  // margin-right: 4px;
}


.elem-name {
  width: 600px;
  position: absolute;
  background: var(--boxbg);
  height: 36px;
  padding-right: 20px;
  overflow-x: auto;
  z-index: 2;
  left: 0px;
  padding-left:24px;

  .name {
    padding-right: 8px;
  }
}

.elem-first-stats {
  margin-left: 700px;
}

/* Estilos básicos para a div principal */
.campaign-container {
}

/* Estilo para a barra de rolagem superior */
.scrollbar-top {
  overflow-x: auto;
  overflow-y: hidden;
  height: 20px; /* Tamanho da barra de rolagem */
  margin-bottom: 10px;

  .scroll-content {
    width: 5500px;
  }
}

/* Estilo para a div de conteúdo com classe campaign */
.ads {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 28px;
}

.lh-info {
  min-width: 840px;
}

.selected {
  background: #EDF2F4;
}

.tag {
  background: #22222212;
  padding: 4px 8px;
  border-radius: 8px;
}

.negative {
  color: red;
}
.positive {
  color: green
}



ul::-webkit-scrollbar {
  width: 10px !important;
  height: 25px !important;
}
ul::-webkit-scrollbar-thumb {
    background-color: #b12031;
    border-radius: 20px;
    border: 10px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
}

@media screen and (max-width: 1024px) {
  .elem-name {
    position: relative !important;
    width: 500px !important;
  }
  .elem-first-stats {
    margin-left: 0px !important;
  }
}


</style>
